import { Offer, PublisherData } from '../../../../../../contracts';

const ZENDESK_FIELD_IDS = {
  PLAYER_ID: 25438695019421,
  ORDER_ID: 25438747117213,
  PROJECT_ID: 25438782685085,
  COUNTRY: 25438841537437,
  PROJECT_NAME: 23783406389789,
  COMPANY: 25474794377117,
};

export const generateZendeskSupportURL = ({
  checkoutData,
  publisherId,
  publisherData,
}: {
  checkoutData?: Offer;
  publisherId?: string;
  publisherData?: PublisherData;
}) => {
  return `https://appchargeHelp.zendesk.com/hc/en-us/requests/new?tf_${
    ZENDESK_FIELD_IDS.PLAYER_ID
  }=${checkoutData?.customer.id || ''}&tf_${ZENDESK_FIELD_IDS.ORDER_ID}=${
    checkoutData?.orderId || ''
  }&tf_${ZENDESK_FIELD_IDS.PROJECT_ID}=${publisherId || ''}&tf_${ZENDESK_FIELD_IDS.COMPANY}=${
    publisherData?.companyId || ''
  }&tf_25438841537437=${checkoutData?.customer.geoLocator.countryCode2 || ''}&tf_${
    ZENDESK_FIELD_IDS.PROJECT_NAME
  }=${publisherData?.companyName || ''}`;
};
